import * as R from 'ramda';
import { HouseholdMember } from './household/householdMember';
import { IAppState } from '../core/redux/IAppState';
import { ACTION_TYPE } from '../core/redux/actionType';
import { keyFor } from '../core/redux/api/module';


/**
 * A list of characters or sequences that are not allowed in guest searches.
 */
export const SEARCH_BLACKLIST = [
  '%',
];


/**
 * Makes a new app state with the given household. Also removes any household loading/errors, because you can't
 * still be loading/erroring if you have a household.
 */
export const addHousehold = (state: IAppState, members: HouseholdMember[]): IAppState => ({
  ...state,
  loading:    members.reduce(
    (running, next) => running.remove(keyFor(ACTION_TYPE.HOUSEHOLD_REQUEST, next.masterGuestId)),
    state.loading,
  ),
  error:      members.reduce(
    (running, next) => running.remove(keyFor(ACTION_TYPE.HOUSEHOLD_REQUEST, next.masterGuestId)),
    state.error,
  ),
  households: R.concat([members], state.households),
});


/**
 * Returns the matching household from app state given a guest Id if a match exists.
 */
export const getHousehold = (
  state: IAppState,
  guestId: string,
): HouseholdMember[] | undefined => R.find(
  household => R.any(member => member.masterGuestId === guestId, household),
  state.households,
);
